import {useEffect, useLayoutEffect, useState} from 'react';

const APP_OPEN_FALLBACK_MS = 2500;

export const isMobileUserAgent = () =>
  typeof navigator !== 'undefined' &&
  /Android|iPhone|iPad/i.test(navigator.userAgent);

/** Immediately tries sayyad:// on mobile; shows pending state until fallback timeout. */
const useMobileAppDeepLink = (enabled = true) => {
  const isMobileUa = isMobileUserAgent();
  const shouldTryOpen = enabled && isMobileUa;
  const [appOpenPending, setAppOpenPending] = useState(shouldTryOpen);

  useLayoutEffect(() => {
    if (!shouldTryOpen) {
      setAppOpenPending(false);
      return;
    }

    setAppOpenPending(true);
    window.location.replace('sayyad://');
  }, [shouldTryOpen]);

  useEffect(() => {
    if (!shouldTryOpen) {
      return;
    }

    const fallbackTimer = window.setTimeout(() => {
      setAppOpenPending(false);
    }, APP_OPEN_FALLBACK_MS);

    return () => clearTimeout(fallbackTimer);
  }, [shouldTryOpen]);

  return {isMobileUa, appOpenPending};
};

export default useMobileAppDeepLink;
